import { useMarkdownStyle } from "../../components/markdown/MarkdownStyleContext";
import { markdownSizesFor } from "../../components/markdown/markdownSizes";
import { sameNodePosition, } from "../../components/markdown/utils";
import { cn } from "../../lib";
import { cva } from "class-variance-authority";
import React, { memo } from "react";
export const paragraphBlockVariants = cva(["whitespace-pre-wrap break-words font-normal first:pt-0 last:pb-0"], {
    variants: {
        compactSpacing: {
            true: ["py-0"],
            false: ["py-1 @md:pt-2 @md:pb-[10px] @md:leading-relaxed"],
        },
    },
});
export const ParagraphBlock = memo(({ children }) => {
    const { textColor, forcedTextSize, textSize: size, compactSpacing, } = useMarkdownStyle();
    const textSize = forcedTextSize !== null && forcedTextSize !== void 0 ? forcedTextSize : markdownSizesFor(size).paragraph;
    return (React.createElement("div", { className: cn(paragraphBlockVariants({ compactSpacing }), textSize, textColor) }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node));
ParagraphBlock.displayName = "ParagraphBlock";
//# sourceMappingURL=ParagraphBlock.js.map